export default __webpack_public_path__ + "src/images/packages/shipwreck-lodge/e7a3d20d421c5b823af7a877586caeb3-4.jpeg";